import { UseGqlMutationCallbacks, useMutationWithInvalidation } from '@alice-financial/api'
import { useMutationNotifier } from '../../../../notifications/useMutationNotifier'
import {
  AcceptOrderFormMutation,
  AcceptOrderFormMutationVariables,
  useAcceptOrderFormMutation,
} from './acceptOrderForm_gen'

type UseAcceptOrderFormMutationOptions = UseGqlMutationCallbacks<
  AcceptOrderFormMutation,
  AcceptOrderFormMutationVariables
>

export const useAcceptOrderForm = (orgId: number, mutationOptions?: UseAcceptOrderFormMutationOptions) => {
  const { mutateAsync: acceptOrderForm } = useAcceptOrderFormMutation()
  const optionsWithNotification = useMutationNotifier({}, mutationOptions)
  return useMutationWithInvalidation(acceptOrderForm, optionsWithNotification, 'all')
}
